<template lang="pug">
v-layout(align-center justify-center)
  v-flex(xs12 sm7 md5 lg4)
    v-card(flat)
      v-img(:src='bg' aspect-ratio='1.9').white--text
        .logo: Logo(small)

      v-card-text
        v-form
          v-text-field.mb-3(prepend-icon='person' name='username' :placeholder='$t("id")' type='text' v-model.trim='id' browser-autocomplete='username' spellcheck='false' :disabled='isLoading' @keyup.enter='login' autofocus flat hide-details)
          v-text-field(prepend-icon='lock' name='password' :placeholder='$t("password")' type='password' v-model.trim='password' @keyup.enter='login' browser-autocomplete='current-password' :error='!!error' :disabled='isLoading' flat hide-details)

      v-card-actions
        v-fade-transition(mode='out-in')
          p.error--text.px-3(v-if='error') {{ error }}
          p.grey--text.px-3(v-else-if='progress' :key='progress') {{ progress }}
        v-spacer
        v-btn(color='primary' depressed @click='login' :loading='isLoading' :disabled='isLoading')
          v-icon(small) fas fa-chevron-right

    .mt-3(:style="{ textAlign: 'center' }")
      small
        a(href='https://mcip.app/' :style="{ textDecoration: 'none' }") 樂台計畫
        |  © 2018 - {{ (new Date()).getFullYear()  }}
</template>

<script>
import sha512 from 'js-sha512'
import { login } from '@/mixins/login'
import apis from '@/assets/js/apis'
import auth from '@/assets/js/auth'

import Logo from '@/components/Logo.vue'

export default {
  name: 'Login',
  metaInfo () {
    return {
      title: this.$t('Login'),
    }
  },
  data () {
    return {
      id: '',
      password: '',
      error: null,
      progress: null,
      isLoading: false,
    }
  },
  mounted () {
    if (this.checkLogin()) this.$router.push({ name: 'home' })
    setTimeout(() => this.setProgress(this.$t('forStaff')), 500)
  },
  methods: {
    async login () {
      if (this.isLoading || this.isFieldEmpty) return
      this.isLoading = true
      this.error = null
      const schoolId = this.id
      const password = sha512.sha512(this.password)

      try {
        // 驗證登入
        const loginInfo = { schoolId, password }
        const loginResult = await apis.login.post(loginInfo)

        const token = loginResult.token
        const userInfo = loginResult.schoolInfo

        // 設定 status 和 cookie
        this.$store.commit('setToken', token)
        auth.setAuth(token)

        // 從 login 的 res 設定 userInfo
        this.$store.commit('setUserInfo', userInfo)
        this.checkLogin()
        this.$router.push({ name: 'home' })
      } catch (e) {
        this.setError(e)
        this.isLoading = false
      }
    },
    setError (e) {
      const status = (e.response) ? e.response.status || null : null
      if (status >= 400 && status <= 499) {
        this.error = this.$t('pleaseReconfirmIdOrPassword')
      } else {
        this.error = `${this.$t('connectionIssue')} ${e}`
      }
    },
    setProgress (v) {
      this.progress = v
    },

  },
  computed: {
    isFieldEmpty () {
      return !this.id || !this.password
    },
    bg () {
      return 'https://images.unsplash.com/photo-1582721691120-d1db3852893e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80'
    },
  },
  components: {
    Logo,
  },
  mixins: [login],
}
</script>

<style scoped lang="sass">
@keyframes show
  from
    opacity: 0
  to
    transform: 0

.logo
  height: 100%
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column
  img
    display: inline-block
    height: auto
  h1
    font-size: 20px
    font-weight: normal
</style>

<i18n src="@/lang/views/login.json"></i18n>
